import PropTypes from 'prop-types';
import {useState} from 'react';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';
import {HoverHandler} from '@gisatcz/ptr-core';
import {ColumnChart} from '@gisatcz/ptr-charts';

import getRelativeValue from './getRelativeValue';

import './style.scss';

const ReliabilityChart = ({feature}) => {
	const [type, onTypeChange] = useState('absolute');

	const attributes = feature?.properties;
	if (attributes) {
		const count =
			attributes['rel_a'] +
				attributes['rel_b'] +
				attributes['rel_c'] +
				attributes['rel_d'] +
				attributes['rel_e'] || 0;
		let data = [];

		// TODO 0 is added to draw chart grid even if no data
		data.push(
			{
				key: 'A',
				data: {
					value: attributes['rel_a'] || 0,
					relativeValue: getRelativeValue(attributes['rel_a'], count, 1),
					color: '#4487cf',
				},
			},
			{
				key: 'B',
				data: {
					value: attributes['rel_b'] || 0,
					relativeValue: getRelativeValue(attributes['rel_b'], count, 1),
					color: '#4487cf',
				},
			},
			{
				key: 'C',
				data: {
					value: attributes['rel_c'] || 0,
					relativeValue: getRelativeValue(attributes['rel_c'], count, 1),
					color: '#4487cf',
				},
			},
			{
				key: 'D',
				data: {
					value: attributes['rel_d'] || 0,
					relativeValue: getRelativeValue(attributes['rel_d'], count, 1),
					color: '#4487cf',
				},
			},
			{
				key: 'E',
				data: {
					value: attributes['rel_e'] || 0,
					relativeValue: getRelativeValue(attributes['rel_e'], count, 1),
					color: '#4487cf',
				},
			}
		);

		return (
			<div>
				<div className="insar-ZonesChart-header risk-assessment">
					<h6 className="insar-ZonesChart-title">PS reliability classes</h6>
					<ButtonSwitch ghost small onClick={onTypeChange}>
						<ButtonSwitchOption value="relative" active={type === 'relative'}>
							rel
						</ButtonSwitchOption>
						<ButtonSwitchOption value="absolute" active={type === 'absolute'}>
							abs
						</ButtonSwitchOption>
					</ButtonSwitch>
				</div>
				<HoverHandler>
					<ColumnChart
						key="risk"
						data={data}
						keySourcePath="key"
						nameSourcePath="key"
						xSourcePath="key"
						ySourcePath={
							type === 'relative' ? 'data.relativeValue' : 'data.value'
						}
						colorSourcePath="data.color"
						height={10}
						yValuesSize={2}
						xValuesSize={2.7}
						barGapRatio={0.1}
						yOptions={{
							max: type === 'relative' ? 100 : null,
							unit: type === 'relative' ? '%' : null,
						}}
						xLabel
						xOptions={{
							name: 'Classes',
						}}
					/>
				</HoverHandler>
			</div>
		);
	} else {
		return null;
	}
};

ReliabilityChart.propTypes = {
	feature: PropTypes.object,
};

export default ReliabilityChart;
